import { combineReducers } from 'redux'
import _ from 'lodash'

import * as validateResidentsImport from './validate'
import * as executeResidentsImport from './execute'

const slices = {
  validateResidentsImport,
  executeResidentsImport
}

const residentsImportTypes = _.mapValues(slices, (s) => s.slice.types)
const residentsImportActions = Object.assign({}, ..._(slices).values().map('slice.actions').value())
const residentsImportSagas = _(slices).values().map('slice.sagas').flatten().value()
const residentsImportSelectors = Object.assign({}, ..._(slices).values().map('slice.selectors').value())
const reducers = Object.assign({}, ..._(slices).values().map('default').value())

export { residentsImportTypes, residentsImportActions, residentsImportSagas, residentsImportSelectors }

export default combineReducers(reducers)
